import { createRouter, createWebHistory } from 'vue-router';
import persistentData from '@/plugins/persistentData';
import Login from '@/views/Login/Main.vue';
import RecoveryPassword from '@/views/RecoveryPassword.vue';
import Home from '@/views/Home.vue'
import NotAllowed from '@/views/NotAllowedError.vue';
import Register from '@/views/Registration/Main.vue';
import RegisterSuccess from '@/views/Registration/Success.vue';


const guard = (to, from, next) => {
  if (persistentData.get('token') !== null) {
    next()
  } else {
    next('/login')
  }
}

const routes = [
  {
    path: '/login',
    name: 'LOGIN',
    component: Login
  },
  {
    path: '/recoveryPassword',
    name: 'RECOVERY-PASSWORD',
    component: RecoveryPassword
  },
  {
    path: '/',
    name: 'HOME',
    component: Home,
    beforeEnter: guard
  },
  {
    path: '/notAllowed',
    component: NotAllowed,
    name: 'NOT_ALLOWED',
  },
  {
    path: '/register',
    component: Register,
    name: 'REGISTER',
  },
  {
    path: '/register-success',
    component: RegisterSuccess,
    name: 'REGISTER_SUCCESS',
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior () { window.scrollTo(0, 0) }
});

export default router;
